export default "__VITE_PUBLIC_ASSET__ad158fc1__"